import React from 'react';
import { Link } from 'react-router-dom';
export function FamilyRelatedLinks() {
  return <section className="py-12 bg-subtle-gray/30 border-t border-subtle-gray" data-id="element-1129">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1130">
        <p className="text-sm font-bold text-gray-warm uppercase tracking-wide mb-6" data-id="element-1131">
          Explore More Classes & Programs
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-1132">
          <Link to="/karate-kids-classes.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1133">
            Kids Classes
          </Link>
          <Link to="/karate-adult-classes" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1134">
            Adult Classes
          </Link>
          <Link to="/are-martial-arts-for-fitness" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1135">
            Fitness
          </Link>
          <Link to="/Programs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1136">
            Programs Overview
          </Link>
          <Link to="/SignMeUp" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1137">
            Start Trial
          </Link>
          <Link to="/ContactUs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1138">
            Contact
          </Link>
        </div>
      </div>
    </section>;
}